import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiGlobe, FiSun, FiUsers, FiAward } from 'react-icons/fi';

const Careers = () => {
  const reasons = [
    { title: 'Sustainable Mission', icon: FiSun, desc: 'Work on projects that directly contribute to a greener, more sustainable future through clean energy and smart tech.' },
    { title: 'Innovative Culture', icon: FiAward, desc: 'Be part of a team that encourages out-of-the-box thinking and continuous learning in emerging technologies.' },
    { title: 'Collaborative Environment', icon: FiUsers, desc: 'Join a diverse group of engineers, designers, and visionaries working together to solve complex problems.' },
    { title: 'Global Impact', icon: FiGlobe, desc: 'Develop solutions that have the potential to transform industries and improve lives on a global scale.' },
  ];

  return (
    <section id="careers" className="py-24 bg-charcoal relative border-y border-cyan/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4"
          >
            Careers at Vitrotechworld — <br/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon to-cyan">Join the Future of Sustainable Innovation</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-slate-400 text-lg"
          >
            We are always looking for passionate, forward-thinking individuals to join our mission. If you are driven by technology and want to make a real impact, we want to hear from you.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-navy p-8 rounded-2xl border border-cyan/10 hover:border-cyan/30 transition-all flex gap-6 items-start"
            >
              <div className="flex-shrink-0 w-12 h-12 bg-cyan/10 rounded-full flex items-center justify-center text-cyan">
                <SafeIcon icon={reason.icon} className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold text-white mb-2">{reason.title}</h3>
                <p className="text-slate-400 leading-relaxed">{reason.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-cyan/20 to-navy border border-cyan/30 rounded-3xl p-8 sm:p-12 text-center glow-border"
        >
          <h3 className="text-2xl font-heading font-bold text-white mb-4">Ready to shape the future with us?</h3>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">Send your CV and a brief introduction about why you'd be a great fit for our team.</p>
          <a href="mailto:Vitroglobeind@gmail.com" className="inline-flex items-center gap-2 bg-cyan text-navy px-8 py-4 rounded-full font-bold hover:bg-white transition-all shadow-[0_0_20px_rgba(0,240,255,0.3)]">
            Send your CV to: Vitroglobeind@gmail.com
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Careers;